import type { TeacherResponse } from "p6m-p6u";

export const checkHasCompletedProfile = (teacherInfo: TeacherResponse | null | undefined): boolean => {
    if (!teacherInfo) return false;

    const hasSchool = teacherInfo.school?.id !== -1;
    const hasSubjects = teacherInfo.subjects?.length > 0;
    const hasClass = teacherInfo.classLevels?.length > 0;
    // Truthiness on purpose: SSO teachers may have missing (undefined) or empty names.
    const hasName = !!teacherInfo.firstname && !!teacherInfo.lastname;

    return hasSchool && hasSubjects && hasClass && hasName;
};
